import script from "./HelpTemplateDocs.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpTemplateDocs.vue?vue&type=script&setup=true&lang=js"

import "./HelpTemplateDocs.vue?vue&type=style&index=0&id=79ed7484&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ed7484"]])

export default __exports__